import React, { Component } from 'react';
import "./DailyLogs.css";
import { connect } from 'react-redux';
import LibraryApiCall from 'LibraryApiCall';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import config from 'config';
import Pagination from 'react-js-pagination';
import Spinner from 'LIBRARY/CommonResources/SpinnerLoader/Spinner';
import ButtonLoader from 'LIBRARY/CommonResources/ButtonLoader/ButtonLoader';
import CSVReader from 'react-csv-reader'
import { CSVLink } from 'react-csv';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
import moment from "moment";
import ReactHtmlParser from 'react-html-parser';
import ReactToPrint from "react-to-print";
import { ToastContainer, toast } from 'react-toastify';

const papaparseOptions = {}
let matchedPeriodicals = config.institute_id;
let selectedCheckboxIID = []


class DailyLogs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // States for filters
      periodicalTitleFilter: '',
      categoryFilter: '',
      periodicityFilter: '',
      iidFilter: config.institute_id,
      monthFilter: new Date().getMonth() + 1,
      yearFilter: new Date().getFullYear(),
      selectedLogIdsToDelete: [],
      selectedPeriodicalIds: [],
      selectedPeriodicalsData: [],
      logSearchIID: config.institute_id,
      filterPeriodicalCategoryData: [],

      multipleInstituteDetails: this.props.multipleInstituteDetails.multipleInstituteDetails,

      periodicalListLoading: false,
      periodicalAllData: {},
      totalRecords: '',
      sortedIdArray: [],

      offset: 0,
      pageIndex: 1,
      limit: 10,

      PeriodicalTitle: '',
      addLogsModal: false,
      addButtonDisabled: false,

      updateLogsModal: false,
      isUpdate: false,
      updateModalStatus: 'active',

      // States to add logs for periodicals
      logs: [
        {
          id: 1,
          periodical: '',
          EditorName: '',
          receivedDate: '',
          receivedDateWarning: '',
          volumeNumber: '',
          volumeNumberWarning: '',
          issueNumber: '',
          issueNumberWarning: '',
          copiesNumber: '',
          copiesNumberWarning: '',
          pricePerCopy: '',
          logUniqueId: '',
          deleteStatus: 'active',
          status: 'Pending',
          periodicalIId: ''
        }
      ],
      totalPrice: 0,

      periodicalList: {},
      periodicalsLoading: false,

      importValid: true,
      importErrorMgs: true,

      slotDatesWarning: '',
      slotStartDate: '',
      slotEndDate: '',
      selectedDateRange: null,

      periodicalFilterData: {},
      periodicalFilterDataLoading: false,

      selectedCSVFiles: {},
      csvData: [],
      postPeriodicalHeadersArray: [],
      postPeriodicalDetailsArray: [],
      validations: {
        headersErrors: [],
        dataErrors: {},
        isDataValid: false,
        isHeadersValid: false,
        isVerified: false,
      },

      selectedLogPeriodicalValue: config.institute_id,
      allPeriodicalData: {},
      allPeriodicalDailyLogData: {}
    }
  }

  componentDidMount() {
    this.getPeriodicalWiseDailyLogs();
    this.calculateTotalPrice();
    this.getPeriodicalList();
    this.getAllPeriodicalList();
    this.getAllPeriodicalWiseDailyLogs();

    // filter 
    this.filterGetPeriodicalCategoryList();

    // document.getElementById('receivedDateId').value = '';
    var { monthFilter, yearFilter } = this.state;

    // Ensure the month is two digits
    monthFilter = String(monthFilter).padStart(2, '0');

    // Start date: first day of the month
    const MonthStartDate = moment(`${yearFilter}-${monthFilter}-01`);

    // End date: last day of the month
    const MonthEndDate = MonthStartDate.clone().endOf('month');

    // Format the dates to get YYYY-MM-DD
    const formattedStartDate = MonthStartDate.format('YYYY-MM-DD');
    const formattedEndDate = MonthEndDate.format('YYYY-MM-DD');

    this.setState({
      slotStartDate: formattedStartDate,
      slotEndDate: formattedEndDate
    });

  }

  filterGetPeriodicalCategoryList = async () => {

    let multipleInstistuteStreamValue = Array.isArray(this.state.logSearchIID)
      ? this.state.logSearchIID
      : [this.state.logSearchIID];

    let requestData = {
      "iidArray": multipleInstistuteStreamValue
    };

    let jsonResponse = await LibraryApiCall.makeApiCall(
      'getLibraryPeriodicalCategoryList',
      requestData,
      '/api/library/library.php'
    );

    if (jsonResponse.expired) {
      setTimeout(() => {
        this.filterGetPeriodicalCategoryList();
      }, 1000);
    } else {
      if (jsonResponse.success) {
        let apiResult = jsonResponse.APIResult.data;
        this.setState({
          filterPeriodicalCategoryData: apiResult,
        });
      }
    }
  }

  // API CALL METHOD TO GET PERIODICAL LIST
  getPeriodicalList = async () => {

    this.setState({
      periodicalsLoading: true
    });

    let requestData = {
      "iid": config.institute_id,
      "pageIndex": this.state.pageIndex,
      "limitPerPage": this.state.limit,
      "filterData": {
        "title": this.state.PeriodicalTitle,
        "periodicity": '',
        "periodical_category_id": ''
      },
      "status": 'active',
      "iidArray": this.props.iidArray.iidArray
    };

    let jsonResponse = await LibraryApiCall.makeApiCall(
      'getPeriodicalList',
      requestData,
      '/api/library/instructor.php'
    );

    if (jsonResponse.expired) {
      setTimeout(() => {
        this.getPeriodicalList();
      }, 1000);
    } else {
      if (jsonResponse.success) {
        let apiResult = jsonResponse.APIResult;
        this.setState({
          periodicalList: apiResult.data,
          periodicalsLoading: true
        });

      }
    }
  }

  // API CALL METHOD TO GET ALL PERIODICAL LIST
  getAllPeriodicalList = async () => {

    this.setState({
      periodicalsLoading: true
    });

    let requestData = {
      "iid": config.institute_id,
      "pageIndex": "all",
      "limitPerPage": "all",
      "filterData": {
        "title": '',
        "periodicity": '',
        "periodical_category_id": ''
      },
      "status": 'active',
      "iidArray": this.props.iidArray.iidArray
    };

    let jsonResponse = await LibraryApiCall.makeApiCall(
      'getPeriodicalList',
      requestData,
      '/api/library/instructor.php'
    );

    if (jsonResponse.expired) {
      setTimeout(() => {
        this.getAllPeriodicalList();
      }, 1000);
    } else {
      if (jsonResponse.success) {
        let apiResult = jsonResponse.APIResult;
        this.setState({
          allPeriodicalData: apiResult.data,
        });

      }
    }
  }

  // API CALL METHOD TO GET LOGS LIST
  getAllPeriodicalWiseDailyLogs = async () => {

    this.setState({
      periodicalListLoading: true
    });

    let requestData = {
      "iid": config.institute_id,
      // "pageIndex": this.state.pageIndex,
      // "limitPerPage": this.state.limit,
      "periodicalIdArray": this.props.selectedPeriodicalIdForLog != "" ? [this.props.selectedPeriodicalIdForLog] : [],
      "month": this.state.monthFilter,
      "year": this.state.yearFilter,
      "startDate": this.state.slotStartDate,
      "endDate": this.state.slotEndDate,
      "periodicalTitle": this.state.periodicalTitleFilter,
      "periodicity": this.state.periodicityFilter,
      "categoryId": this.state.categoryFilter,
      "status": 'active',
      "iidArray": this.props.iidArray.iidArray,
    };

    let jsonResponse = await LibraryApiCall.makeApiCall(
      'getPeriodicalDailyLogsList',
      requestData,
      '/api/library/libraryPeriodicals.php'
    );

    if (jsonResponse.expired) {
      setTimeout(() => {
        this.getPeriodicalWiseDailyLogs();
      }, 1000);
    } else {
      if (jsonResponse.success) {
        let apiResult = jsonResponse.APIResult;
        this.setState({
          allPeriodicalDailyLogData: apiResult.data,
        });

      }
    }
  }

  // Method called to get total price
  calculateTotalPrice = () => {

    var totalPrice = this.state.logs.reduce((total, log) => {

      if (log.deleteStatus == 'inactive') {

        return total;

      }

      if (log.copiesNumber == '' || log.copiesNumber == 0) {
        return total;

      } else {

        return total + (log.copiesNumber * log.pricePerCopy);
      }
    }, 0);

    this.setState({ totalPrice });

  }

  // API CALL METHOD TO GET LOGS LIST
  getPeriodicalWiseDailyLogs = async () => {

    this.setState({
      periodicalListLoading: true
    });

    let multipleInstistuteValue = Array.isArray(this.state.logSearchIID)
      ? this.state.logSearchIID
      : [this.state.logSearchIID];

    let requestData = {
      "iid": config.institute_id,
      // "pageIndex": this.state.pageIndex,
      // "limitPerPage": this.state.limit,
      "periodicalIdArray": this.props.selectedPeriodicalIdForLog != "" ? [this.props.selectedPeriodicalIdForLog] : [],
      "month": this.state.monthFilter,
      "year": this.state.yearFilter,
      "startDate": this.state.slotStartDate,
      "endDate": this.state.slotEndDate,
      "periodicalTitle": this.state.periodicalTitleFilter,
      "periodicity": this.state.periodicityFilter,
      "categoryId": this.state.categoryFilter,
      "status": 'active',
      "iidArray": multipleInstistuteValue,
    };

    let jsonResponse = await LibraryApiCall.makeApiCall(
      'getPeriodicalDailyLogsList',
      requestData,
      '/api/library/libraryPeriodicals.php'
    );

    if (jsonResponse.expired) {
      setTimeout(() => {
        this.getPeriodicalWiseDailyLogs();
      }, 1000);
    } else {
      if (jsonResponse.success) {
        let apiResult = jsonResponse.APIResult;
        this.setState({
          periodicalAllData: apiResult.data,
          // totalRecords: apiResult.totalRecords,
          periodicalListLoading: false,
          sortedIdArray: apiResult.sortedIdArray,
          selectedPeriodicalIds: [],
        });

      }
    }
  }

  // API CALL METHOD TO GET FILTERED LOGS LIST
  getFilteredPeriodicalWiseDailyLogs = async () => {

    this.setState({
      periodicalFilterDataLoading: true
    });

    let requestData = {
      "iid": config.institute_id,
      // "pageIndex": this.state.pageIndex,
      // "limitPerPage": this.state.limit,
      // "periodicalIdArray": [], 
      "startDate": this.state.slotStartDate,
      "endDate": this.state.slotEndDate,
      "status": this.state.updateModalStatus,
      "iidArray": this.props.iidArray.iidArray
    };

    let jsonResponse = await LibraryApiCall.makeApiCall(
      'getPeriodicalDailyLogsList',
      requestData,
      '/api/library/libraryPeriodicals.php'
    );

    if (jsonResponse.expired) {
      setTimeout(() => {
        this.getFilteredPeriodicalWiseDailyLogs();
      }, 1000);
    } else {
      if (jsonResponse.success) {
        let apiResult = jsonResponse.APIResult;
        this.setState({
          periodicalFilterData: apiResult.data,
          // totalRecords: apiResult.totalRecords,
          periodicalFilterDataLoading: false,
        });

        const filterData = apiResult.data;
        const { selectedPeriodicalIds } = this.state;
        const selectedPeriodicalsData = selectedPeriodicalIds.map(id => filterData[id]).filter(data => data !== undefined);
        this.setState({ selectedPeriodicalsData });
        const updateLogs = selectedPeriodicalsData.map((periodical, index) => {
          const { title, periodicalUID, logs, periodicalIID } = periodical;

          // Mapped each log entry to the required format
          const mappedLogs = Object.keys(logs).map((date) => ({
            id: index + 1,
            periodical: title,
            periodicalIId: periodicalIID,
            EditorName: logs[date].editor || '',
            receivedDate: logs[date].receivedDate || '',
            receivedDateWarning: '',
            volumeNumber: logs[date].volume || '',
            volumeNumberWarning: '',
            issueNumber: logs[date].issueNo || '',
            issueNumberWarning: '',
            copiesNumber: logs[date].noOfCopies,
            copiesNumberWarning: '',
            pricePerCopy: logs[date].pricePerCopy || '',
            logUniqueId: logs[date].logUniqueId || '',
            deleteStatus: logs[date].status || 'active',
            status: 'Success'
          }));

          return mappedLogs;
        });

        if (this.state.updateLogsModal) {
          this.setState({
            logs: updateLogs.flat()

          }, this.calculateTotalPrice)
        }

      }
    }
  }

  // METHOD TO SELECT LIMIT
  selectLimit = (e) => {
    this.setState({
      limit: e.target.value,
      pageIndex: 1,
      offset: 0,
      selectedPeriodicalIds: []
    }, () => {
      // METHOD CALLED TO GET MEMBER DETAILS
      this.getPeriodicalWiseDailyLogs();
    });
  }

  // METHOD TO UPDATE PAGINATION PAGE NUMBER
  updatePaginationCount = (pageNumber) => {
    this.setState({
      pageIndex: pageNumber,
      offset: (pageNumber - 1) * this.state.limit,
      selectedMemberIds: []
    }, () => {
      // METHOD CALLED TO GET MEMBER DETAILS
      this.getPeriodicalWiseDailyLogs();
    });
  }

  // Function to get all days in a particular month and year
  getDaysInMonth() {
    const { monthFilter, yearFilter } = this.state;
    let days = [];

    const jsMonth = monthFilter - 1;

    let date = new Date(yearFilter, jsMonth, 1);

    while (date.getMonth() === jsMonth) {
      days.push(new Date(date));
      date.setDate(date.getDate() + 1);
    }

    return days;
  }

  // Method called to clear filter
  clearFilter = () => {
    this.setState({
      offset: 0,
      pageIndex: 1,
      categoryFilter: '',
      periodicalTitleFilter: '',
      periodicityFilter: '',
      monthFilter: new Date().getMonth() + 1,
      yearFilter: new Date().getFullYear(),
      iidFilter: config.institute_id,
      logSearchIID: config.institute_id
    }, () => this.getPeriodicalWiseDailyLogs())
  }

  // METHOD TO SELECT SINGLE LOG
  selectSinglePeriodical = (periodicalId) => {

    let selectedPeriodicalIds = this.state.selectedPeriodicalIds;

    if (selectedPeriodicalIds.includes(periodicalId)) {
      selectedPeriodicalIds = selectedPeriodicalIds.filter(id => id != periodicalId);
    } else {
      selectedPeriodicalIds.push(periodicalId);
    }

    if (selectedPeriodicalIds.length > 0) {
      this.setState({
        showValidDates: true,
      });
    } else {
      this.setState({
        showValidDates: false,
        validFromDate: '',
        validToDate: '',
        isDateEmpty: false
      });
    }

    this.setState({
      selectedPeriodicalIds,
    });

  }

  // METHOD TO SELECT ALL LOGS
  selectAllPeriodicals = (e) => {
    let periodicalSet = new Set();

    if (e.target.checked) {
      if (Object.keys(this.state.periodicalAllData).length > 0) {
        Object.keys(this.state.periodicalAllData).map(periodicalId => {
          periodicalSet.add(periodicalId);
        });
      }
      this.setState({
        showValidDates: true,
      });
    } else {
      this.setState({
        showValidDates: false,
        validFromDate: '',
        validToDate: '',
        isDateEmpty: false
      });
    }

    this.setState({
      selectedPeriodicalIds: Array.from(periodicalSet),
    });
  }

  // METHOD TO SELECT SINGLE LOG
  selectSingleLogToDelete = (logId) => {

    let selectedLogIdsToDelete = this.state.selectedLogIdsToDelete;

    if (selectedLogIdsToDelete.includes(logId)) {
      selectedLogIdsToDelete = selectedLogIdsToDelete.filter(id => id != logId);
    } else {
      selectedLogIdsToDelete.push(logId);
    }

    this.setState({
      selectedLogIdsToDelete,
    });
  }

  // METHOD TO SELECT ALL LOGS
  selectAllLogsToDelete = (e) => {
    let logSet = new Set();

    if (e.target.checked) {
      if (this.state.logs.length > 0) {
        this.state.logs.map((logId, index) => {
          logSet.add(index);
        });
      }
    }

    this.setState({
      selectedLogIdsToDelete: Array.from(logSet),
    });
  }

  // Method to open add modal
  addlogsModal = () => {

    const addGrantAccess = this.props.isAdmin == true ? true : this.props.accessibleOperations['periodicals'].find(access => access === 'add');

    if (addGrantAccess !== undefined) {

      this.setState({
        addLogsModal: true,
        addButtonDisabled: false,
        isUpdate: false
      })

    } else {
      this.setState({
        successModal: true,
        successModalType: 'warning',
        successMessage: 'This operation is restricted by the Library admin.'
      });
    }
  }

  closeAddLogsModal = () => {
    this.setState({
      addLogsModal: false,
      totalPrice: 0,
      importErrorMgs: '',
      PeriodicalTitle: '',
      logs: [
        {
          id: 1,
          periodical: '',
          EditorName: '',
          receivedDate: '',
          receivedDateWarning: '',
          volumeNumber: '',
          volumeNumberWarning: '',
          issueNumber: '',
          issueNumberWarning: '',
          copiesNumber: '',
          copiesNumberWarning: '',
          pricePerCopy: '',
          logUniqueId: '',
          deleteStatus: 'active',
          periodicalIId: '',
          status: 'Pending'
        }
      ],
    }, () => this.getPeriodicalWiseDailyLogs())
  }

  // Method to open update modal
  updatelogsModal = (type) => {

    const hasDifferentIID = new Set(selectedCheckboxIID).size > 1;

    if (hasDifferentIID) {
      this.setState({ selectedPeriodicalIds: [] })
      toast.warn("Please select periodicals from the same Institute to perform this action.", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      if (type == 'update') {

        const editGrantAccess = this.props.isAdmin == true ? true : this.props.accessibleOperations['periodicals'].find(access => access === 'edit');

        if (editGrantAccess !== undefined) {

          this.setState({
            isUpdate: true,
            updateLogsModal: true,
          }, this.getFilteredPeriodicalWiseDailyLogs)

        } else {
          this.setState({
            successModal: true,
            successModalType: 'warning',
            successMessage: 'This operation is restricted by the Library admin.'
          });
        }
      } else {
        const deleteGrantAccess = this.props.isAdmin == true ? true : this.props.accessibleOperations['periodicals'].find(access => access === 'delete');

        if (deleteGrantAccess !== undefined) {

          this.setState({
            isUpdate: false,
            updateLogsModal: true,
          }, this.getFilteredPeriodicalWiseDailyLogs)

        } else {
          this.setState({
            successModal: true,
            successModalType: 'warning',
            successMessage: 'This operation is restricted by the Library admin.'
          });
        }
      }
    }
  }

  closeUpdateLogsModal = () => {
    this.setState({
      updateLogsModal: false,
      selectedLogIdsToDelete: [],
      totalPrice: 0,
      selectedDateRange: null,
      importErrorMgs: '',
      updateModalStatus: 'active',
      logs: [
        {
          id: 1,
          periodical: '',
          EditorName: '',
          receivedDate: '',
          receivedDateWarning: '',
          volumeNumber: '',
          volumeNumberWarning: '',
          issueNumber: '',
          issueNumberWarning: '',
          copiesNumber: '',
          copiesNumberWarning: '',
          pricePerCopy: '',
          logUniqueId: '',
          deleteStatus: 'active',
          status: 'Pending'
        }
      ],
    }, () => this.getPeriodicalWiseDailyLogs())
    document.getElementById('receivedDateId').value = '';
  }

  // METHOD TO GET PRIODICAL FILTER TITLE
  getPeriodicalListByName = (e) => {
    this.setState({
      PeriodicalTitle: e.target.value,
    }, () => {
      if (e.target.value.trim().length > 0) {
        // METHOD CALLED TO GET PERIODICAL DETAILS
        this.getPeriodicalList();
      } else {
        this.setState({
          periodicalList: {},
          PeriodicalTitle: '',
        });
      }
    });
  }

  // Method to handle add new subcriptions
  isAddButtonDisabled = () => {
    if (this.state.logs.length > 0) {

      const lastLog = this.state.logs[this.state.logs.length - 1];
      const { periodical, receivedDate, copiesNumber, pricePerCopy } = lastLog;
      return !periodical || !receivedDate || !copiesNumber || !pricePerCopy;

    }
  }

  // Method to add new subcriptions
  addLog = () => {
    this.setState((prevState) => {
      const newLogs = {
        id: prevState.logs.length + 1,
        periodical: '',
        receivedDate: '',
        receivedDateWarning: '',
        volumeNumber: '',
        volumeNumberWarning: '',
        issueNumber: '',
        issueNumberWarning: '',
        copiesNumber: '',
        copiesNumberWarning: '',
        pricePerCopy: '',
        deleteStatus: 'active',
        periodicalIId: '',
        status: 'Pending'
      };
      return { logs: [...prevState.logs, newLogs] };
    }, this.calculateTotalPrice);

    this.setState({
      PeriodicalTitle: ''
    })
  }

  // Method to add new subcriptions
  handleInputChange = (id, field, value) => {

    var logIndex = id - 1;

    if (field == 'deleteStatus') {
      var statusDelete = '';

      var tempLogs = this.state.logs;
      var existingDeleteStatus = tempLogs[logIndex]['deleteStatus'];
      var existingStatus = tempLogs[logIndex]['status'];
      tempLogs[logIndex]['deleteStatus'] = existingDeleteStatus === 'active' ? 'inactive' : 'active';

      if (this.state.isUpdate) {
        tempLogs[logIndex]['status'] = 'Pending';
      }

      this.setState({
        logs: tempLogs
      }, () => {
        this.calculateTotalPrice();
        if (!this.state.isUpdate) {
          this.apiCallToDeleteLogDetails(logIndex, statusDelete)
        }
      })

      // this.setState((prevState) => {
      //   const logs = prevState.logs.map((log, i) => {
      //     if (i + 1 === id) {
      //       statusDelete = log.deleteStatus === 'active' ? 'inactive' : 'active';
      //       return { ...log, deleteStatus: statusDelete };
      //     }
      //     return log;
      //   });
      //   return { logs };
      // }, () => {
      //   this.calculateTotalPrice;
      //   if (!this.state.isUpdate) {
      //     this.apiCallToDeleteLogDetails(id - 1, statusDelete)
      //   }
      // });

    } else {

      if (this.state.isUpdate) {
        this.setState((prevState) => {
          const logs = prevState.logs.map((log, index) => {
            if (index === logIndex) {

              return { ...log, [field]: value, periodicalIID: this.state.selectedLogPeriodicalValue, status: 'Pending' };

            }
            return log;
          });
          return { logs };

        }, this.calculateTotalPrice);
      }
      else {

        this.setState((prevState) => {
          const logs = prevState.logs.map((log, index) => {
            if (index === logIndex) {

              return { ...log, [field]: value, periodicalIID: this.state.selectedLogPeriodicalValue };

            }
            return log;
          });
          return { logs };

        }, this.calculateTotalPrice);
      }
    }
  }

  // Method to delete logs
  deleteLogs = (id) => {
    this.setState((prevState) => {
      let logs;

      if (prevState.logs.length === 1) {
        const logs = prevState.logs.map((subscription, index) => {
          if (index + 1 === id) {
            return {
              id: index + 1,
              periodical: '',
              EditorName: '',
              receivedDate: '',
              receivedDateWarning: '',
              volumeNumber: '',
              volumeNumberWarning: '',
              issueNumber: '',
              issueNumberWarning: '',
              copiesNumber: '',
              copiesNumberWarning: '',
              pricePerCopy: '',
              deleteStatus: 'active',
              periodicalIId: '',
              status: 'Pending'
            };
          }
          return logs;
        });
        // logs = [];
        return { logs };
      } else {
        const logs = prevState.logs.filter((log, index) => index + 1 !== id);
        return { logs };
      }
    }, this.calculateTotalPrice);
  }

  // EXPORT TABLE TO CSV
  tableToCSV = () => {
    // Creating csv string with headers
    let csvString = `\n"Periodical","Editor","Received Date * (yyyy-mm-dd)","Volume Number","Issue Number","Number of Copy *","Price Per Copy *"\n`;

    // Adding sample hard-coded data
    const sampleData = [
      ["Teacher Plus", "Jr. Christopher Robinson", "2024-01-29", "1", "2", "1", "200"],
    ];

    // Adding each row of sample data to csvString
    sampleData.forEach(row => {
      csvString += `"${row.join('","')}"\n`;
    });

    if (csvString !== '') {
      var downloadLink = document.createElement('a');
      downloadLink.download = "sample-daily-logs-details.csv";
      downloadLink.href = 'data:application/csv;charset=UTF-8,%EF%BB%BF' + encodeURIComponent(csvString);
      downloadLink.target = '_blank';
      document.getElementById('exportList').appendChild(downloadLink);
      downloadLink.click();
    }
  }

  // EXPORT TABLE TO CSV for update
  tableToCSVForUpdate = () => {
    // Creating csv string with headers
    let csvString = `\n"Periodical","Editor","Received Date * (yyyy-mm-dd)","Volume Number","Issue Number","Number of Copy *","Price Per Copy *"\n`;

    console.log(this.state.logs);

    // // Adding sample hard-coded data
    // const sampleData = [
    //   ["Teacher Plus", "Jr. Christopher Robinson", "2024-01-29", "1", "2", "1", "200"],
    // ];

    // // Adding each row of sample data to csvString
    // sampleData.forEach(row => {
    //   csvString += `"${row.join('","')}"\n`;
    // });

    // Assuming this.state.logs is defined and populated
    const logs = this.state.logs;

    // Append each row of logs to csvString
    logs.forEach(log => {
      const row = [
        log.periodical,
        log.EditorName,
        log.receivedDate,
        log.volumeNumber,
        log.issueNumber,
        log.copiesNumber,
        log.pricePerCopy
      ];
      csvString += `"${row.join('","')}"\n`;
    });

    // Now csvString contains the CSV representation of this.state.logs
    console.log(csvString);

    if (csvString !== '') {
      var downloadLink = document.createElement('a');
      downloadLink.download = "sample-daily-logs-details.csv";
      downloadLink.href = 'data:application/csv;charset=UTF-8,%EF%BB%BF' + encodeURIComponent(csvString);
      downloadLink.target = '_blank';
      document.getElementById('exportList').appendChild(downloadLink);
      downloadLink.click();
    }
  }

  // OPEN FILE
  openFileInput = () => {
    document.getElementById("react-csv-reader-input").click();
  }

  // REMOVE SELECTED CSV FILE
  removeCSVFile = () => {
    this.setState({
      selectedCSVFiles: {},
      csvData: [],
      postPeriodicalDetailsArray: [],
      postPeriodicalHeadersArray: [],

      validations: {
        headersErrors: [],
        dataErrors: {},
        isDataValid: false,
        isHeadersValid: false,
        isVerified: false,
      },
      verifiedData: [],
    })
  }

  handleCSVInput = (csvData, fileInformation) => {
    this.setState({
      selectedCSVFiles: fileInformation
    });

    if (fileInformation.type !== "text/csv") {
      this.setState({
        selectedCSVFiles: {},
        successModal: true,
        successModalType: "error",
        successMessage: "Please select csv file.",
        isValidAttachment: false
      });
    } else {
      let postPeriodicalDetailsArray = [];
      let postPeriodicalHeadersArray = [];

      if (csvData.length > 0) {
        csvData = csvData.filter((rowArray, index) => rowArray.length > 1 && !rowArray.every((val) => val === ""));

        // Read CSV Headers
        let headers = csvData[0];

        if (headers !== undefined && headers.length > 0) {
          headers.forEach((headerName) => {
            if (headerName !== undefined) {
              postPeriodicalHeadersArray.push(headerName.trim());
            }
          });
        }

        // Read CSV Actual Body Data
        if (postPeriodicalHeadersArray.length > 0) {
          csvData.forEach((csvRow, index) => {
            if (index !== 0) {
              let logsObject = {};

              for (let i = 0; i < postPeriodicalHeadersArray.length; i++) {
                if (csvRow[i] === undefined || csvRow[i] === null || csvRow[i] === "") {
                  logsObject[postPeriodicalHeadersArray[i]] = "";
                } else {
                  logsObject[postPeriodicalHeadersArray[i]] = csvRow[i];
                }
              }

              postPeriodicalDetailsArray.push({ ...logsObject, verificationStatus: "pending", importStatus: "pending", loading: false });
            }
          });
        }
      }

      this.setState({
        csvData: [...csvData],
        postPeriodicalDetailsArray: postPeriodicalDetailsArray,
        postPeriodicalHeadersArray: postPeriodicalHeadersArray
      }, () => {
        // Transform the postPeriodicalDetailsArray to match the logs structure
        const newLogs = postPeriodicalDetailsArray.map((detail, index) => ({
          id: this.state.logs.length + index + 1,
          periodical: detail.Periodical || '',
          EditorName: detail.Editor || '',
          receivedDate: detail['Received Date * (yyyy-mm-dd)'] || '',
          receivedDateWarning: '',
          volumeNumber: detail['Volume Number'] || '',
          volumeNumberWarning: '',
          issueNumber: detail['Issue Number'] || '',
          issueNumberWarning: '',
          copiesNumber: detail['Number of Copy *'] || '',
          copiesNumberWarning: '',
          pricePerCopy: detail['Price Per Copy *'] || '',
          logUniqueId: '',
          deleteStatus: 'active',
          status: 'Pending'
        }));

        // Check if all existing logs are empty
        const allLogsEmpty = this.state.logs.every(log =>
          !log.periodical &&
          !log.EditorName &&
          !log.receivedDate &&
          !log.volumeNumber &&
          !log.issueNumber &&
          !log.copiesNumber &&
          !log.pricePerCopy
        );

        // Append or replace based on the condition
        // if (allLogsEmpty) {
        //   this.setState({ logs: newLogs }, this.validateCSVFileHeaders);
        // } else {
        //   this.setState((prevState) => ({
        //     logs: [...prevState.logs, ...newLogs]
        //   }), this.validateCSVFileHeaders);
        // }

        if (this.state.isUpdate) {
          let isMatched = true;
          let matchingDetail = '';

          const updatedLogs = this.state.logs.map(log => {

            // const matchingDetail = postPeriodicalDetailsArray.find((detail) =>{

            //   console.log(detail.Periodical.trim(), 'detail.Periodical.trim()');
            //   console.log(log.periodical.trim(), 'log.periodical.trim()');

            //   console.log(detail['Received Date * (yyyy-mm-dd)'], 'detail-Received Date * (yyyy-mm-dd)');
            //   console.log(log.receivedDate, 'log.receivedDate');

            //   detail.Periodical.trim()  === log.periodical.trim()  && detail['Received Date * (yyyy-mm-dd)']  === log.receivedDate
            // }

            // );


            postPeriodicalDetailsArray.map(detail => {

              if (detail.Periodical.trim() === log.periodical.trim() && detail['Received Date * (yyyy-mm-dd)'] === log.receivedDate) {
                matchingDetail = detail;
              }

            }

            );

            if (matchingDetail) {
              return {
                ...log,
                periodical: matchingDetail.Periodical || '',
                EditorName: matchingDetail.Editor || '',
                // EditorName: matchingDetail['Editor'] || '',
                receivedDate: matchingDetail['Received Date * (yyyy-mm-dd)'] || '',
                volumeNumber: matchingDetail['Volume Number'] || '',
                issueNumber: matchingDetail['Issue Number'] || '',
                copiesNumber: matchingDetail['Number of Copy *'] || '',
                pricePerCopy: matchingDetail['Price Per Copy *'] || '',
                status: 'Pending'
              };
            } else {
              isMatched = false;

              return log;
            }
          });

          if (!isMatched) {
            toast.success(`There are no entries for the specified periodicals on the received dates given in the CSV to update.`, {
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
          this.setState({ logs: updatedLogs }, this.validateCSVFileHeaders);
        } else {
          // If isUpdate is false, append or replace logs as usual
          if (allLogsEmpty) {
            this.setState({ logs: newLogs }, this.validateCSVFileHeaders);
          } else {
            this.setState((prevState) => ({
              logs: [...prevState.logs, ...newLogs]
            }), this.validateCSVFileHeaders);
          }
        }
      });
    }
  }

  // VALIDATE CSV FILE HEADERS
  validateCSVFileHeaders = () => {
    let commonHeaders = ["Periodical", "Editor", "Received Date * (yyyy-mm-dd)", "Volume Number", "Issue Number", "Number of Copy *", "Price Per Copy *"]
    let mandatoryHeaders = ["Periodical", "Received Date * (yyyy-mm-dd)", "Number of Copy *", "Price Per Copy *"]
    let postPeriodicalHeadersArray = this.state.postPeriodicalHeadersArray;
    let validations = this.state.validations;

    if (postPeriodicalHeadersArray.length > 0) {
      // Checking Default periodical Headers are available or not.
      mandatoryHeaders.map((header, index) => {
        if (!postPeriodicalHeadersArray.includes(header)) {
          let validationObject = {
            touch: true,
            cell: index + 1,
            row: 0,
            status: "error",
            message: `${header} is mandatory column to import periodical.`,
            type: "header",
            errorCount: 0
          }
          validations['headersErrors'].push(validationObject)
          validations['isHeadersValid'] = false;
        }
      })

      // Checking Dyanamic periodical Headers are available or not.
      postPeriodicalHeadersArray.map((key, index) => {
        let validationObject = {
          touch: false,
          cell: index + 1,
          row: 0,
          status: "error",
          message: "",
          type: "header",
          errorCount: 0
        }

        let isValidHeader = commonHeaders.some((keys) => {
          return keys == key.trim();
        })

        if (!isValidHeader) {
          validationObject.cell = index + 1;
          validationObject.status = "error";
          validationObject.message = `Please check default headers. ${key} header is invalid.`;
          validationObject.touch = true;
        }

        if (validationObject.touch) {
          validations['headersErrors'].push(validationObject)
          validations['isHeadersValid'] = false;
        }
      })
    }

    if (validations['headersErrors'].length == 0) {
      validations['isHeadersValid'] = true;
    }

    this.setState({
      validations: { ...validations }
    }, this.calculateTotalPrice)
  }

  // METHOD TO RETURN ADD LOGS
  returnAddLogs = () => {
    return (
      <div className={this.state.addLogsModal ? "modal fade show" : "modal fade"} id="modalContainer" >
        <div class="modal-dialog modal-dialog-centered" style={{ maxWidth: '90VW', minHeight: "calc(100% - 13.5rem)" }}>
          <div class="modal-content">
            <div class="modal-header" style={{ padding: '15px' }}>
              <h5 class="modal-title">Add Daily Logs</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true" onClick={() => { this.closeAddLogsModal(); this.removeCSVFile(); }}>&times;</span>
              </button>
            </div>
            <div class="modal-body pl-0 pr-0 pb-0" style={{ maxHeight: '90vh' }}>
              <div className='d-flex justify-content-between col-md-12 mb-2'>
                <span className='fs-14'>Periodical Log Table</span>
                <span className='importActionBox'>
                  <FontAwesomeIcon data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" size='md' style={{ float: 'right', cursor: 'pointer', border: 'none', backgroundColor: 'transparent', color: '#0465AC' }} title="Click here to import" icon={["fa", "file-import"]} onClick={this.openImportPeriodicalModal} />

                  <div className="dropdown-menu dropdown-menu-right">
                    <div style={{ display: "none" }}>
                      <CSVReader
                        cssClass="csv-reader-input"
                        label="Select CSV file"
                        onFileLoaded={this.handleCSVInput}
                        parserOptions={papaparseOptions}
                      />
                    </div>

                    {
                      Object.keys(this.state.selectedCSVFiles).length > 0 ?
                        <span className='SelectedFileBox m-2 d-flex' title={this.state.selectedCSVFiles['name']}>
                          <span>
                            <FontAwesomeIcon color='#007BFF' icon={['fas', 'file-alt']} size={'md'}></FontAwesomeIcon>&nbsp;&nbsp;
                            <span className='fs-13'>
                              {this.state.selectedCSVFiles['name'].length > 15
                                ? `${this.state.selectedCSVFiles['name'].substring(0, 15)}...`
                                : this.state.selectedCSVFiles['name']}
                            </span>&nbsp;
                            <span className="delete-icon" onClick={this.removeCSVFile}>
                              <FontAwesomeIcon icon={['fas', 'times']} size={'sm'}></FontAwesomeIcon>&nbsp;&nbsp;
                              {/* <FontAwesomeIcon icon={['fas', 'check']} size={'sm'}></FontAwesomeIcon> */}
                            </span>
                          </span>
                        </span>
                        :
                        <div className='chooseFileBox m-2' onClick={this.openFileInput}>
                          <span className='fs-15' style={{ color: '#007BFF' }}>
                            <FontAwesomeIcon size='sm' icon={["fa", "upload"]} />&nbsp;&nbsp;
                            Choose file
                          </span>
                        </div>
                    }
                    <div>
                      <div className='SampleFileBox m-2' onClick={this.tableToCSV}>
                        <span className='fs-15' style={{ color: '#198719' }}>
                          <FontAwesomeIcon size='sm' icon={["fa", "download"]} />&nbsp;&nbsp;
                          Download Sample File
                        </span>
                      </div>
                    </div>
                  </div>
                  <div id="exportList"></div>
                </span>
              </div>
              <div className='col-md-12'>
                <div className='addLogsFrame pl-2 pt-3 pr-1' style={{ overflowY: 'auto' }}>
                  <div className="">
                    <table className='col-md-12 pt-3' style={{ borderCollapse: 'collapse', width: '100%' }}>
                      <thead>
                        <tr>
                          <th className='fs-13 headColor' style={{ padding: '5px', textAlign: 'left' }}>Status</th>
                          <th className='fs-13 headColor' style={{ padding: '5px', textAlign: 'left' }}>Periodical <span className='text-danger'>*</span></th>
                          <th className='fs-13 headColor' style={{ padding: '5px', textAlign: 'left' }}>Editor</th>
                          <th className='fs-13 headColor' style={{ padding: '5px', textAlign: 'left' }}>Received Date <span className='text-danger'>*</span><span className='fs-12'>(yyyy-mm-dd)</span></th>
                          <th className='fs-13 headColor' style={{ padding: '5px', textAlign: 'left' }}>Volume Number</th>
                          <th className='fs-13 headColor' style={{ padding: '5px', textAlign: 'left' }}>Issue Number</th>
                          <th className='fs-13 headColor' style={{ padding: '5px', textAlign: 'left' }}>Number of Copy <span className='text-danger'>*</span></th>
                          <th className='fs-13 headColor' style={{ padding: '5px', textAlign: 'left' }}>Price Per Copy <span className='text-danger'>*</span></th>
                        </tr>
                      </thead>
                      <tbody className=''>
                        {
                          this.state.logs.length > 0 ?
                            this.state.logs.map((log, index) => (
                              <tr key={index + 1} className='pt-1' style={{ backgroundColor: log.status === 'failed' ? '#FF49491A' : 'transparent' }}>
                                <td style={{ fontWeight: 'bold', padding: '5px', color: log.status === 'Success' ? 'green' : log.status === 'Pending' && log.status === 'pending' && '#00000' }}>{
                                  log.status == 'failed' ?
                                    <button type="button" className="btn import-btn"
                                      style={{ padding: '3px 6px !important' }} onClick={() =>
                                        this.apiCallToImportLogDetails('add', index, 'true')
                                      }>
                                      <span style={{ fontSize: '12px !important' }}>Retry</span>
                                    </button>
                                    : log.status
                                }</td>
                                <td style={{ padding: '5px' }}>
                                  <div className="dropdown">
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Click to select periodical"
                                      style={{ fontSize: '15px' }}
                                      value={log.periodical}
                                      data-toggle="dropdown"
                                      readOnly
                                    />
                                    <div className="dropdown-menu eventSelectionMenu">
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search Periodical"
                                        style={{ fontSize: '14px' }}
                                        value={this.state.PeriodicalTitle}
                                        onChange={(e) => this.getPeriodicalListByName(e)}
                                      />
                                      {
                                        this.state.PeriodicalTitle.trim().length > 0 ?
                                          <>
                                            {
                                              this.state.periodicalListLoading ?
                                                <ButtonLoader />
                                                :
                                                Object.keys(this.state.periodicalList).length > 0 ?
                                                  Object.values(this.state.periodicalList).map(periodical => (
                                                    <p key={periodical.id} className="searchedEvent fs-14" title={periodical.title + " | " + periodical.periodicalInstituteName} style={{ cursor: 'pointer' }}
                                                      onClick={() => {
                                                        this.setState({ PeriodicalTitle: periodical.title, selectedLogPeriodicalValue: periodical.periodicalIID }, () => {
                                                          this.handleInputChange(index + 1, 'periodical', periodical.title);
                                                        });
                                                      }}>{periodical.title + " | " + periodical.periodicalInstituteName}</p>
                                                  ))
                                                  :
                                                  <p style={{ fontSize: 13, color: '#818181' }}>No periodical details found.</p>
                                            }
                                          </>
                                          :
                                          <p style={{ fontSize: 13, color: '#818181' }}>Please search periodical to get details.</p>
                                      }
                                    </div>
                                  </div>
                                </td>
                                <td style={{ padding: '5px' }}>
                                  <input
                                    type="text"
                                    className="form-control"
                                    style={{ paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px', fontSize: '15px' }}
                                    placeholder="Enter Editor Name"
                                    value={log.EditorName}
                                    onChange={(e) => this.handleInputChange(index + 1, 'EditorName', e.target.value)}
                                  />
                                </td>
                                <td style={{ padding: '5px' }}>
                                  <input
                                    type="date"
                                    className="form-control"
                                    style={{ paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px', fontSize: '15px' }}
                                    placeholder=""
                                    value={log.receivedDate}
                                    onChange={(e) => this.handleInputChange(index + 1, 'receivedDate', e.target.value)}
                                  />
                                </td>
                                <td style={{ padding: '5px' }}>
                                  <input
                                    type="number"
                                    className="form-control"
                                    style={{ paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px', fontSize: '15px' }}
                                    placeholder="Enter Volume"
                                    value={log.volumeNumber}
                                    onChange={(e) => this.handleInputChange(index + 1, 'volumeNumber', e.target.value)}
                                  />
                                </td>
                                <td style={{ padding: '5px' }}>
                                  <input
                                    type="number"
                                    className="form-control"
                                    style={{ paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px', fontSize: '15px' }}
                                    placeholder="Enter Issue Number"
                                    value={log.issueNumber}
                                    onChange={(e) => this.handleInputChange(index + 1, 'issueNumber', e.target.value)}

                                  />
                                </td>
                                <td style={{ padding: '5px' }}>
                                  <input
                                    type="number"
                                    className="form-control"
                                    style={{ paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px', marginRight: '0px', fontSize: '15px' }}
                                    placeholder="Enter Number of Copy"
                                    value={log.copiesNumber}
                                    onChange={(e) => {
                                      if (/^\d*$/.test(e.target.value)) {
                                        this.handleInputChange(index + 1, 'copiesNumber', e.target.value);
                                      }
                                    }
                                    }
                                  />
                                </td>
                                <td style={{ padding: '5px' }}>
                                  <span className='d-flex mr-0'>
                                    <input
                                      type="text"
                                      className="form-control col"
                                      style={{ fontSize: '15px', maxWidth: '20%', paddingLeft: '7px', paddingTop: '4px', paddingBottom: '3px', marginRight: '3px' }}
                                      disabled
                                      value="₹"
                                    />
                                    <input
                                      type="number"
                                      className="form-control"
                                      style={{ fontSize: '15px', maxWidth: '77%', paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px' }}
                                      placeholder="Enter Price"
                                      value={log.pricePerCopy}
                                      onChange={(e) => {
                                        // Check if the input is a positive number
                                        if (/^\d*\.?\d{0,3}$/.test(e.target.value) || e.target.value === '') {
                                          this.handleInputChange(index + 1, 'pricePerCopy', e.target.value)
                                        }
                                      }}
                                    />
                                  </span>
                                </td>
                                {
                                  (log.status === 'Pending' || log.status === 'pending') &&
                                  <td className='mr-4'><FontAwesomeIcon color='#8a8a8a' onClick={() => this.deleteLogs(index + 1)} style={{ fontSize: '18px', cursor: 'pointer' }} icon={["fa", "times-circle"]} /></td>
                                }
                              </tr>
                            ))
                            :
                            <tr>
                              <td colSpan="8" style={{ textAlign: 'center', padding: '5px' }}>No logs available</td>
                            </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                  <p className='fs-14 pl-2 py-4 fw-600'
                    style={{
                      color: this.isAddButtonDisabled() ? '#A0A0A0' : '#004D86',
                      textDecoration: 'underline',
                      cursor: this.isAddButtonDisabled() ? 'default' : 'pointer'
                    }}
                    onClick={!this.isAddButtonDisabled() ? this.addLog : null}
                  >+ Add Log</p>
                </div>

                <div className='col-md-12 pr-0 pt-1'>
                  <div className='d-flex justify-content-between ml-2'>
                    <span>
                      {
                        this.state.csvData.length > 0 && !this.state.validations['isHeadersValid'] &&
                        <div className="" style={{ maxHeight: '10vh', overflow: "auto" }}>
                          {
                            Object.values(this.state.validations['headersErrors']).map((item) => {
                              return <p className="text-danger fs-12 my-2">Header {item.cell}-{item.message}</p>
                            })
                          }
                        </div>
                      }
                      {
                        this.state.importValid == 'false' &&
                        <>
                          <p className='fs-13 text-danger'>{this.state.importErrorMgs}</p>
                          <p className='fs-12'><span className='text-danger'>*</span>Note : Errors are indicated by red boxes. Please click on the red boxes to correct them.</p>
                        </>
                      }
                    </span>
                    <span className='d-flex'>
                      <span className='pl-0 pt-2 mr-1 fs-16'>Total Price (in Rs.)</span>
                      <input
                        type="text"
                        className="form-control"
                        style={{ paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px', maxWidth: '40px' }}
                        disabled
                        value="₹"
                      />
                      <input
                        type="text"
                        className="form-control ml-1"
                        style={{ paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px', maxWidth: '150px' }}
                        disabled
                        value={Number.isNaN(this.state.totalPrice) ? 0 : this.state.totalPrice}
                      />
                    </span>
                  </div>
                </div>

              </div>
            </div>
            <div className="modal-footer pt-1">
              <button className="btn btn-outline-primary waves-effect p-2" style={{ fontSize: '13px !important' }} onClick={() => { this.closeAddLogsModal(); this.removeCSVFile() }}><span className='fs-13'>Cancel</span></button>
              <button className="btn btn-primary"
                onClick={() => this.apiCallToImportLogDetails('add', 0)}
                disabled={this.state.addButtonDisabled}
              >Add log</button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // select from and to date
  setFilterDate = (event, picker) => {
    let startDate = picker.startDate['_d'];
    let formattedStartDate = moment(startDate).format('YYYY-MM-DD');

    let endDate = picker.endDate['_d'];
    let formattedEndDate = moment(endDate).format('YYYY-MM-DD');

    if (formattedStartDate != undefined && formattedStartDate != "") {
      this.setState({
        slotStartDate: formattedStartDate
      })
    }

    if (formattedEndDate != undefined && formattedEndDate != "") {
      this.setState({
        slotEndDate: formattedEndDate
      })
    }
    this.getFilteredPeriodicalWiseDailyLogs();
  }

  handleCancel = (event, picker) => {
    picker.element.val('');
  };

  // METHOD TO RETURN UPDATE LOGS
  returnUpdateLogs = () => {
    const { selectedPeriodicalsData, slotStartDate, slotEndDate } = this.state;
    const selectedPeriodicalsTitles = selectedPeriodicalsData.map(periodical => periodical.title).join(', ');
    return (
      <div className={this.state.updateLogsModal ? "modal fade show" : "modal fade"} id="modalContainer" >
        <div class="modal-dialog modal-dialog-centered" style={{ maxWidth: '90VW', minHeight: "calc(100% - 13.5rem)" }}>
          <div class="modal-content">
            <div class="modal-header" style={{ padding: '15px' }}>
              <h5 class="modal-title">{this.state.isUpdate ? 'Update Logs' : 'Delete Logs'}</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true" onClick={() => { this.closeUpdateLogsModal(); this.removeCSVFile(); }}>&times;</span>
              </button>
            </div>
            <div class="modal-body pl-0 pr-0 pb-0" style={{ maxHeight: '90vh' }}>
              <span className='fs-14 col-md-12'>Range of Periodical Received Date</span>
              {this.state.isUpdate && <span className='fs-14 col-md-12'>Status</span>}
              <div className='d-flex justify-content-between col-md-12 mb-2 mt-1'>
                <span className='d-flex'>
                  <span>
                    <DateRangePicker
                      onApply={this.setFilterDate}
                      ref={this.keyRef}
                      onCancel={this.handleCancel}
                    >
                      <input class="form-control" style={{ padding: '10px', fontSize: "12px !important" }}
                        placeholder={`${slotStartDate} - ${slotEndDate}`}
                        id='receivedDateId'
                        value=""
                      />
                    </DateRangePicker>
                  </span> &nbsp;&nbsp;&nbsp;
                  {
                    this.state.isUpdate &&
                    <span>
                      <select className="form-control"
                        style={{ fontSize: '13px' }}
                        value={this.state.updateModalStatus}
                        onChange={(e) => this.setState({ updateModalStatus: e.target.value }, this.getFilteredPeriodicalWiseDailyLogs)}
                      >
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                      </select>
                    </span>
                  }
                </span>
                {
                  this.state.isUpdate &&
                  <span className='importActionBox'>
                    <FontAwesomeIcon data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" size='md' style={{ float: 'right', cursor: 'pointer', border: 'none', backgroundColor: 'transparent', color: '#0465AC' }} title="Click here to import" icon={["fa", "file-import"]} onClick={this.openImportPeriodicalModal} />

                    <div className="dropdown-menu dropdown-menu-right">
                      <div style={{ display: "none" }}>
                        <CSVReader
                          cssClass="csv-reader-input"
                          label="Select CSV file"
                          onFileLoaded={this.handleCSVInput}
                          parserOptions={papaparseOptions}
                        />
                      </div>

                      {
                        Object.keys(this.state.selectedCSVFiles).length > 0 ?
                          <span className='SelectedFileBox m-2 d-flex' title={this.state.selectedCSVFiles['name']}>
                            <span>
                              <FontAwesomeIcon color='#007BFF' icon={['fas', 'file-alt']} size={'md'}></FontAwesomeIcon>&nbsp;&nbsp;
                              <span className='fs-13'>
                                {this.state.selectedCSVFiles['name'].length > 15
                                  ? `${this.state.selectedCSVFiles['name'].substring(0, 15)}...`
                                  : this.state.selectedCSVFiles['name']}
                              </span>&nbsp;
                              <span className="delete-icon" onClick={this.removeCSVFile}>
                                <FontAwesomeIcon icon={['fas', 'times']} size={'sm'}></FontAwesomeIcon>&nbsp;&nbsp;
                                {/* <FontAwesomeIcon icon={['fas', 'check']} size={'sm'}></FontAwesomeIcon> */}
                              </span>
                            </span>
                          </span>
                          :
                          <div className='chooseFileBox m-2' onClick={this.openFileInput}>
                            <span className='fs-15' style={{ color: '#007BFF' }}>
                              <FontAwesomeIcon size='sm' icon={["fa", "upload"]} />&nbsp;&nbsp;
                              Choose file
                            </span>
                          </div>
                      }
                      <div>
                        <div className='SampleFileBox m-2' onClick={this.tableToCSVForUpdate}>
                          <span className='fs-15' style={{ color: '#198719' }}>
                            <FontAwesomeIcon size='sm' icon={["fa", "download"]} />&nbsp;&nbsp;
                            Download Sample File
                          </span>
                        </div>
                      </div>
                    </div>
                    <div id="exportList"></div>
                  </span>
                }
              </div>
              <div className='col-md-12'>
                {
                  this.state.isUpdate &&
                  <div className='selectedPeriodicalList mb-2 p-1'>
                    <span title={selectedPeriodicalsTitles} className='fs-13'><span style={{ color: '#656565', fontWeight: 'bold' }}>Update Logs For :</span> {selectedPeriodicalsTitles.length > 80 ? selectedPeriodicalsTitles.substring(0, 80) + '...' : selectedPeriodicalsTitles} </span>
                    {
                      (this.state.slotStartDate && this.state.slotEndDate) &&
                      <span style={{ float: 'right' }} className='fs-13 mt-1'>
                        <span style={{ color: '#656565', fontWeight: 'bold' }}>Logs Between : </span>
                        {`${moment(this.state.slotStartDate).format('Do MMM, YYYY')} - ${moment(this.state.slotEndDate).format('Do MMM, YYYY')}`}
                      </span>
                    }
                  </div>
                  // :
                  // <div className='deleteNote mb-2 p-2'>
                  //   <p style={{ fontSize: '13px', color: '#252525' }}>The selected daily logs will be deleted permanently and the data can not be retrieved later.</p>
                  // </div>
                }
              </div>
              <div className='col-md-12'>
                <div className='addLogsFrame pl-2 pt-3 pr-1' style={{ overflowY: 'auto' }}>
                  <div className="">
                    <table className='col-md-12 pt-3' style={{ borderCollapse: 'collapse', width: '100%' }}>
                      <thead>
                        <tr>
                          {
                            this.state.isUpdate ?
                              <th className='fs-13 headColor' style={{ padding: '5px', textAlign: 'left' }}>Status</th>
                              :
                              <th style={{ padding: '5px', textAlign: 'left' }}>
                                <input
                                  type="checkbox"
                                  checked={this.state.logs.length > 0 && (this.state.logs.length == this.state.selectedLogIdsToDelete.length)}
                                  onChange={(e) => this.selectAllLogsToDelete(e)}
                                  style={{ marginRight: 5 }}
                                />
                              </th>
                          }
                          <th className='fs-13 headColor' style={{ padding: '5px', textAlign: 'left' }}>Periodical <span className='text-danger'>*</span></th>
                          <th className='fs-13 headColor' style={{ padding: '5px', textAlign: 'left' }}>Editor</th>
                          <th className='fs-13 headColor' style={{ padding: '5px', textAlign: 'left' }}>Received Date <span className='text-danger'>*</span><span className='fs-12'>(yyyy-mm-dd)</span></th>
                          <th className='fs-13 headColor' style={{ padding: '5px', textAlign: 'left' }}>Volume Number</th>
                          <th className='fs-13 headColor' style={{ padding: '5px', textAlign: 'left' }}>Issue Number</th>
                          <th className='fs-13 headColor' style={{ padding: '5px', textAlign: 'left' }}>Number of Copy <span className='text-danger'>*</span></th>
                          <th className='fs-13 headColor' style={{ padding: '5px', textAlign: 'left' }}>Price Per Copy <span className='text-danger'>*</span></th>
                          <th className='fs-13 headColor' style={{ padding: '5px', textAlign: 'left' }}>Active/Inactive</th>
                        </tr>
                        {
                          this.state.selectedLogIdsToDelete.length > 0 &&
                          <tr style={{ backgroundColor: "#EFEFEF" }}>
                            <th colSpan='9' style={{ padding: '10px' }}>
                              <div className="">
                                <span id="actionOnLogs" title="Click to delete daily logs" onClick={() => this.apiCallToDeleteLogDetails('all', 'inactive')}>
                                  Delete Logs
                                </span>
                              </div>
                            </th>
                          </tr>
                        }
                      </thead>
                      <tbody className=''>
                        {
                          this.state.periodicalFilterDataLoading ?
                            <tr>
                              <Spinner />
                            </tr>
                            :
                            this.state.logs.length > 0 ?
                              this.state.logs.map((log, index) => {
                                return (
                                  <tr key={index + 1} className='pt-1' style={{ backgroundColor: log.status === 'failed' ? '#FF49491A' : 'transparent' }}>
                                    {
                                      this.state.isUpdate ?
                                        <td style={{ fontWeight: 'bold', padding: '5px', color: log.status === 'Success' ? 'green' : log.status === 'Pending' && log.status === 'pending' && '#00000' }}>
                                          {
                                            log.status == 'failed' ?
                                              <button type="button" className="btn import-btn"
                                                style={{ padding: '3px 6px !important' }}
                                                onClick={() =>
                                                  this.apiCallToImportLogDetails('update', index, 'true')
                                                }
                                              >
                                                <span style={{ fontSize: '12px !important' }}>Retry</span>
                                              </button>
                                              : log.status
                                          }
                                        </td>
                                        :
                                        <td style={{ padding: '5px' }}>
                                          <input
                                            type="checkbox"
                                            checked={this.state.selectedLogIdsToDelete.includes(index)}
                                            disabled={log.deleteStatus == 'inactive'}
                                            onChange={() => this.selectSingleLogToDelete(index)}
                                            style={{ marginRight: 5 }}
                                          />
                                        </td>
                                    }
                                    <td style={{ padding: '5px' }}>
                                      <div className="dropdown">
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Click to select periodical"
                                          style={{ fontSize: '15px' }}
                                          value={log.periodical}
                                          data-toggle="dropdown"
                                          disabled
                                        />
                                        {/* <div className="dropdown-menu eventSelectionMenu">
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search Periodical"
                                        style={{ fontSize: '14px' }}
                                        value={this.state.PeriodicalTitle}
                                        onChange={(e) => this.getPeriodicalListByName(e)}
                                      />
                                      {
                                        this.state.PeriodicalTitle.trim().length > 0 ?
                                          <>
                                            {
                                              this.state.periodicalListLoading ?
                                                <ButtonLoader />
                                                :
                                                Object.keys(this.state.periodicalList).length > 0 ?
                                                  Object.values(this.state.periodicalList).map(periodical => (
                                                    <p key={periodical.id} className="searchedEvent fs-14" title={periodical.title}
                                                      onClick={() => {
                                                        this.setState({ PeriodicalTitle: periodical.title }, () => {
                                                          this.handleInputChange(index + 1, 'periodical', periodical.title);
                                                        });
                                                      }}>{periodical.title}</p>
                                                  ))
                                                  :
                                                  <p style={{ fontSize: 13, color: '#818181' }}>No periodical details found.</p>
                                            }
                                          </>
                                          :
                                          <p style={{ fontSize: 13, color: '#818181' }}>Please search periodical to get details.</p>
                                      }
                                    </div> */}
                                      </div>
                                    </td>
                                    <td style={{ padding: '5px' }}>
                                      <input
                                        type="text"
                                        className="form-control"
                                        style={{ paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px', fontSize: '15px' }}
                                        placeholder="Enter Editor Name"
                                        value={log.EditorName}
                                        disabled={!this.state.isUpdate}
                                        onChange={(e) => this.handleInputChange(index + 1, 'EditorName', e.target.value)}
                                      />
                                    </td>
                                    <td style={{ padding: '5px' }}>
                                      <input
                                        type="date"
                                        className="form-control"
                                        style={{ paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px', fontSize: '15px' }}
                                        placeholder=""
                                        value={log.receivedDate}
                                        disabled={!this.state.isUpdate}
                                        onChange={(e) => this.handleInputChange(index + 1, 'receivedDate', e.target.value)}
                                      />
                                    </td>
                                    <td style={{ padding: '5px' }}>
                                      <input
                                        type="number"
                                        className="form-control"
                                        style={{ paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px', fontSize: '15px' }}
                                        placeholder="Enter Volume"
                                        value={log.volumeNumber}
                                        disabled={!this.state.isUpdate}
                                        onChange={(e) => this.handleInputChange(index + 1, 'volumeNumber', e.target.value)}
                                      />
                                    </td>
                                    <td style={{ padding: '5px' }}>
                                      <input
                                        type="number"
                                        className="form-control"
                                        style={{ paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px', fontSize: '15px' }}
                                        placeholder="Enter Issue Number"
                                        value={log.issueNumber}
                                        disabled={!this.state.isUpdate}
                                        onChange={(e) => this.handleInputChange(index + 1, 'issueNumber', e.target.value)}
                                      />
                                    </td>
                                    <td style={{ padding: '5px' }}>
                                      <input
                                        type="number"
                                        className="form-control"
                                        style={{ paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px', marginRight: '0px', fontSize: '15px' }}
                                        placeholder="Enter Number of Copy"
                                        value={log.copiesNumber}
                                        disabled={!this.state.isUpdate}
                                        onChange={(e) => {
                                          if (/^\d*$/.test(e.target.value)) {
                                            this.handleInputChange(index + 1, 'copiesNumber', e.target.value);
                                          }
                                        }
                                        }
                                      />
                                    </td>
                                    <td style={{ padding: '5px' }}>
                                      <span className='d-flex mr-0'>
                                        <input
                                          type="text"
                                          className="form-control col"
                                          style={{ fontSize: '15px', maxWidth: '20%', paddingLeft: '7px', paddingTop: '4px', paddingBottom: '3px', marginRight: '3px' }}
                                          disabled
                                          value="₹"
                                        />
                                        <input
                                          type="number"
                                          className="form-control"
                                          style={{ fontSize: '15px', maxWidth: '77%', paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px' }}
                                          placeholder="Enter Price"
                                          value={log.pricePerCopy}
                                          disabled={!this.state.isUpdate}
                                          onChange={(e) => {
                                            if (/^\d*\.?\d{0,3}$/.test(e.target.value) || e.target.value === '') {
                                              this.handleInputChange(index + 1, 'pricePerCopy', e.target.value)
                                            }
                                          }
                                          }
                                        />
                                      </span>
                                    </td>
                                    <td>
                                      <label className="switch">
                                        <input
                                          type="checkbox"
                                          checked={log.deleteStatus === 'active'}
                                          onChange={(e) => { this.handleInputChange(index + 1, 'deleteStatus', e.target.checked ? 'active' : 'inactive') }}
                                        />
                                        <span className="slider"></span>
                                      </label>
                                    </td>
                                  </tr>
                                )
                              })
                              :
                              <tr>
                                <td colSpan="9" style={{ textAlign: 'center', padding: '5px' }}>No logs available</td>
                              </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className='col-md-12 pr-0 pt-1'>
                  <div className='d-flex justify-content-between ml-2'>
                    <span>
                      {
                        this.state.csvData.length > 0 && !this.state.validations['isHeadersValid'] &&
                        <div className="" style={{ maxHeight: '10vh', overflow: "auto" }}>
                          {
                            Object.values(this.state.validations['headersErrors']).map((item) => {
                              return <p className="text-danger fs-12 my-2">Header {item.cell}-{item.message}</p>
                            })
                          }
                        </div>
                      }
                      {
                        this.state.importValid == 'false' &&
                        <>
                          <p className='fs-13 text-danger'>{this.state.importErrorMgs}</p>
                          <p className='fs-12'><span className='text-danger'>*</span>Note : Errors are indicated by red boxes. Please click on the red boxes to correct them.</p>
                        </>
                      }
                    </span>
                    <span className='d-flex'>
                      <span className='pl-0 pt-2 mr-1 fs-16'>Total Price (in Rs.)</span>
                      <input
                        type="text"
                        className="form-control"
                        style={{ paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px', maxWidth: '40px' }}
                        disabled
                        value="₹"
                      />
                      <input
                        type="text"
                        className="form-control ml-1"
                        style={{ paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px', maxWidth: '150px' }}
                        disabled
                        value={Number.isNaN(this.state.totalPrice) ? 0 : this.state.totalPrice}
                      />
                    </span>
                  </div>
                </div>

              </div>
            </div>
            <div className="modal-footer pt-1">
              <button className="btn btn-outline-primary waves-effect p-2" style={{ fontSize: '13px !important' }} onClick={() => { this.closeUpdateLogsModal(); this.removeCSVFile() }}><span className='fs-13'>Cancel</span></button>
              {
                this.state.isUpdate &&
                <button className="btn btn-primary"
                  onClick={() => this.apiCallToImportLogDetails('update', 0)}
                >Update Logs</button>}
            </div>
          </div>
        </div>
      </div>
    );
  }

  // API CALL TO IMPORT Logs
  apiCallToImportLogDetails = async (action, rowIndex, isRetry = "") => {

    if (rowIndex < this.state.logs.length) {
      let periodicalData = this.state.logs[rowIndex];
      matchedPeriodicals = '';

      if (periodicalData['status'] != 'Success') {

        let periodical = periodicalData['periodical'];
        let editor = periodicalData['EditorName'];
        let receivedDate = periodicalData['receivedDate'];
        let volume = periodicalData['volumeNumber'];
        let issueNumber = periodicalData['issueNumber'];
        let noOfCopies = periodicalData['copiesNumber'];
        let pricePerCopy = periodicalData['pricePerCopy'];
        let logUniqueId = periodicalData['logUniqueId'];
        let deleteStatus = periodicalData['deleteStatus'];
        let selectedPeriodicalIID = periodicalData['periodicalIID'];

        // Filter to get all matches (if any)
        matchedPeriodicals = Object.values(this.state.allPeriodicalData).find(item => item.title === periodicalData['periodical']);

        let requestData = {
          "periodical": periodical,
          "instituteId": selectedPeriodicalIID || config.institute_id, // matchedPeriodicals ? matchedPeriodicals.periodicalIID : config.institute_id,
          "editor": editor,
          "receivedDate": receivedDate,
          "volume": volume,
          "issueNumber": issueNumber,
          "noOfCopies": noOfCopies,
          "pricePerCopy": pricePerCopy,
          "facultyId": config.faculty_id,
          "logUniqueId": logUniqueId,
          "isAddOrEdit": action,
          "deleteStatus": deleteStatus
        }
        this.setState({
          addButtonDisabled: true
        })
        let jsonResponse = await LibraryApiCall.makeApiCall(
          'library_importDailyLogDetails',
          requestData,
          "/api/library/libraryPeriodicals.php"
        );

        if (jsonResponse.expired) {

          setTimeout(() => {
            this.apiCallToImportLogDetails(action, rowIndex, isRetry);
          }, 1000);
        } else {
          if (jsonResponse.success) {
            let apiResult = jsonResponse.APIResult;
            if (apiResult.status == 'success') {
              let postPeriodicalDetailsArray = this.state.postPeriodicalDetailsArray;
              let logs = this.state.logs;

              let rowItem = logs[rowIndex];
              rowItem['status'] = 'Success'
              logs[rowIndex] = rowItem;

              this.setState({
                postPeriodicalDetailsArray: postPeriodicalDetailsArray,
                importValid: apiResult.isValid,
                importErrorMgs: apiResult.message,
              }, () => {
                if (isRetry != "true") {

                  this.apiCallToImportLogDetails(action, rowIndex + 1, isRetry);
                }
              })

            }
            else {
              // let rowIndex = rowIndex + 1;
              let errorObj = {};
              errorObj['row'] = rowIndex;
              errorObj['key'] = apiResult.key;
              errorObj['message'] = apiResult.message;

              let postPeriodicalDetailsArray = this.state.postPeriodicalDetailsArray;
              let logs = this.state.logs;

              let rowItem = logs[rowIndex];
              rowItem['status'] = 'failed'
              logs[rowIndex] = rowItem;

              this.setState({
                postPeriodicalDetailsArray: postPeriodicalDetailsArray,
                importValid: apiResult.isValid,
                importErrorMgs: 'Row' + ' ' + (rowIndex + 1) + ' ' + ':' + ' ' + apiResult.message,
              }, () => {
                if (isRetry != "true") {

                  this.apiCallToImportLogDetails(action, rowIndex + 1, isRetry);
                }
              })

            }
          } else {
            let postPeriodicalDetailsArray = this.state.postPeriodicalDetailsArray;

            this.setState({
              postPeriodicalDetailsArray: postPeriodicalDetailsArray,
            }, () => {

              if (isRetry != "true") {

                this.apiCallToImportLogDetails(action, rowIndex + 1, isRetry);
              }
            })

          }
        }
      }
      else {
        // If the log's status is not 'Success', move to the next log
        this.apiCallToImportLogDetails(action, rowIndex + 1, isRetry);
      }

    } else {
      this.setState({
        addButtonDisabled: false
      })
    }
  }

  // API CALL TO DELETE LOGS
  apiCallToDeleteLogDetails = async (rowIndex, statusDelete) => {

    const { selectedLogIdsToDelete, logs } = this.state;
    const selectedLogsToDelete = selectedLogIdsToDelete.map(id => logs[id]).filter(data => data !== undefined);

    var logUniqueId = '';
    var logUniqueIds = [];

    if (rowIndex != 'all') {

      let periodicalData = logs[rowIndex];
      logUniqueId = periodicalData['logUniqueId'];
      statusDelete = periodicalData['deleteStatus'];
    }
    else {
      logUniqueIds = selectedLogsToDelete.map(log => log.logUniqueId);
    }

    let requestData = {
      "instituteId": selectedCheckboxIID ? selectedCheckboxIID[0] : config.institute_id, // config.institute_id,
      "logUniqueId": rowIndex != 'all' ? [logUniqueId] : logUniqueIds,
      "facultyId": config.faculty_id,
      "statusDelete": statusDelete,
    }

    let jsonResponse = await LibraryApiCall.makeApiCall(
      'library_deleteDailyLogDetails',
      requestData,
      "/api/library/libraryPeriodicals.php"
    );

    if (jsonResponse.expired) {
      setTimeout(() => {
        this.apiCallToDeleteLogDetails()
      }, 1000);
    } else {
      if (jsonResponse.success) {
        let apiResult = jsonResponse.APIResult;
        if (apiResult.status == 'success') {

          const deletedMemberIds = apiResult.deletedMemberIds;

          const filteredData = this.state.logs.filter(item => deletedMemberIds.includes(item.logUniqueId));

          const updatedData = filteredData.map(item => {
            // Toggle the deleteStatus between 'active' and 'inactive'
            return {
              ...item,
              deleteStatus: this.state.selectedLogIdsToDelete.length > 0 ? (item.deleteStatus === 'active' ? 'inactive' : 'active') : item.deleteStatus
            };
          });

          const newLogs = this.state.logs.map(log =>
            updatedData.find(updatedLog => updatedLog.logUniqueId === log.logUniqueId) || log
          );

          this.setState({
            logs: newLogs
          }, this.calculateTotalPrice)

          this.setState({
            selectedLogIdsToDelete: [],
            successModal: true,
            successModalType: 'success',
            successMessage: ReactHtmlParser(apiResult.message),
          });


        } else {
          this.setState({
            successModal: true,
            successModalType: 'warning',
            successMessage: apiResult.message,
          });
        }
      } else {
        this.setState({
          successModal: true,
          successModalType: 'error',
          successMessage: 'Something went wrong while updating logs. Please try again later.',
        });
      }
    }
  }

  // METHOD TO EXPORT LOGS DETAILS
  exportLogDetails = () => {
    this.setState({
      exportDetails: true
    }, () => {
      document.getElementById('logsExport').click();

      this.setState({
        exportDetails: false
      });
    });
  }

  render() {
    const { monthFilter, yearFilter, periodicalAllData } = this.state;
    const dateArray = this.getDaysInMonth();

    // get selected row iid
    selectedCheckboxIID = this.state.selectedPeriodicalIds.map(id => {
      const item = this.state.allPeriodicalData[id];
      return item ? item.periodicalIID : null;
    }).filter(id => id !== null)

    return (
      <>
        <div>
          <div className="d-flex flex-wrap w-100 align-items-end">
            {/* Filters section */}
            <div className="d-flex flex-wrap col-md-10 px-0">
              <div className="row mx-0 w-100">
                {/* Institute */}
                <div className="col-md-2 pl-0 pr-1">
                  <label className="fs-13 headColor">Institute</label>
                  <select
                    className="form-control"
                    style={{ fontSize: "13px" }}
                    value={this.state.iidFilter}
                    onChange={(e) => {
                      const selectedIID = e.target.value;
                      if (selectedIID) {
                        const numericIID = [selectedIID].map(Number);
                        this.setState(
                          { iidFilter: selectedIID, logSearchIID: numericIID },
                          () => {
                            this.filterGetPeriodicalCategoryList();
                          }
                        );
                      } else {
                        this.setState(
                          {
                            iidFilter: '',
                            logSearchIID: this.props.iidArray.iidArray,
                          },
                          () => {
                            this.filterGetPeriodicalCategoryList();

                          }
                        );
                      }
                    }}
                  >
                    <option value="">Select Institute</option>
                    {Object.values(this.state.multipleInstituteDetails).map((member) => (
                      <option key={member?.iid} value={member?.iid}>
                        {member?.institute_name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Periodical Title */}
                <div className="col-md-2 pl-0 pr-1">
                  <label className='fs-13 headColor'>Periodical</label>

                  <input
                    type="text"
                    className="form-control"
                    style={{ fontSize: '13px', paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px' }}
                    placeholder="Search by Title"
                    value={this.state.periodicalTitleFilter}
                    disabled={this.props.selectedPeriodicalIdForLog != ""}
                    onChange={(e) => this.setState({ periodicalTitleFilter: e.target.value })}
                  />
                </div>

                {/* Category */}
                <div className="col-md-2 pl-0 pr-1">
                  <label className='fs-13 headColor'>Category</label>
                  <select className="form-control"
                    style={{ fontSize: '13px' }}
                    value={this.state.categoryFilter}
                    disabled={this.props.selectedPeriodicalIdForLog != ""}
                    onChange={(e) => this.setState({ categoryFilter: e.target.value })}
                  >
                    <option value="">Select Category</option>
                    {
                      Object.keys(this.state.filterPeriodicalCategoryData).map(category => {
                        let categoryName = this.state.filterPeriodicalCategoryData[category]

                        return (
                          <option style={{ fontSize: '13px' }} value={category}> {categoryName.category_name +
                            " | " +
                            categoryName.periodicalCategory_InstituteName}</option>
                        );
                      })
                    }
                  </select>
                </div>

                {/* Periodicity */}
                <div className="col-md-2 pl-0 pr-1">
                  <label className='fs-13 headColor'>Periodicity</label>

                  <select className="form-control"
                    style={{ fontSize: '13px' }}
                    value={this.state.periodicityFilter}
                    disabled={this.props.selectedPeriodicalIdForLog != ""}
                    onChange={(e) => this.setState({ periodicityFilter: e.target.value })}
                  >
                    <option value="">Select Periodicity</option>
                    <option value="daily">Daily</option>
                    <option value="weekly">Weekly</option>
                    <option value="fortnightly">Fortnightly</option>
                    <option value="monthly">Monthly</option>
                    <option value="bimonthly">Bi Monthly</option>
                    <option value="quarterly">Quarterly</option>
                    <option value="half yearly">Half yearly</option>
                    <option value="yearly">Yearly</option>
                    <option value="triennial">Triennial</option>
                    <option value="tri annually">Tri Annually</option>
                  </select>
                </div>

                {/* Month */}
                <div className="col-md-2 pl-0 pr-1">
                  <label className='fs-13 headColor'>Month</label>

                  <select className="form-control"
                    style={{ fontSize: '13px' }}
                    value={this.state.monthFilter}
                    onChange={(e) => this.setState({ monthFilter: e.target.value }
                      // , () => this.getPeriodicalWiseDailyLogs()
                    )
                    }
                  >
                    <option value="1">January</option>
                    <option value="2">February</option>
                    <option value="3">March</option>
                    <option value="4">April</option>
                    <option value="5">May</option>
                    <option value="6">June</option>
                    <option value="7">July</option>
                    <option value="8">August</option>
                    <option value="9">September</option>
                    <option value="10">October</option>
                    <option value="11">November</option>
                    <option value="12">December</option>

                  </select>
                </div>

                {/* Year */}
                <div className="col-md-2 pl-0 pr-1">
                  <label className='fs-13 headColor'>Year</label>

                  <select className="form-control"
                    style={{ fontSize: '13px' }}
                    value={this.state.yearFilter}
                    onChange={(e) => this.setState({ yearFilter: e.target.value }
                      // , () => this.getPeriodicalWiseDailyLogs()
                    )
                    }
                  >
                    <option value="2015">2015</option>
                    <option value="2016">2016</option>
                    <option value="2017">2017</option>
                    <option value="2018">2018</option>
                    <option value="2019">2019</option>
                    <option value="2020">2020</option>
                    <option value="2021">2021</option>
                    <option value="2022">2022</option>
                    <option value="2023">2023</option>
                    <option value="2024">2024</option>
                    <option value="2025">2025</option>
                    <option value="2026">2026</option>
                    <option value="2027">2027</option>
                    <option value="2028">2028</option>
                    <option value="2029">2029</option>
                    <option value="2030">2030</option>
                  </select>
                </div>

                {/* Apply / Clear Buttons */}
                <div className='col-md-2 pl-0 pr-1 mt-4'>
                  <button style={{ fontSize: '12px' }} className="btn btn-primary px-2 py-1 br-5" onClick={() => this.setState({ offset: 0, pageIndex: 1 }, () => this.getPeriodicalWiseDailyLogs())}><span className='fs-12'>Apply</span></button>
                  <button style={{ fontSize: '12px' }} className="btn btn-outline-primary waves-effect px-2 py-1 br-5" onClick={() => this.clearFilter()}><span className='fs-12'>Clear</span></button>
                </div>
              </div>
            </div>

            {/* Buttons section */}
            <div className="d-flex col-md-2 justify-content-end mt-2 mt-md-4">
              <div style={{ display: 'none' }}>
                <ReactHTMLTableToExcel
                  id="logsExport"
                  className="btn outline-button waves-effect text-capitalize"
                  table='studentWiseLibraryReport'
                  filename="Daily logs List"
                  sheet="tablexls"
                  buttonText="Export to Excel"
                />
              </div>
              <span className='actionBox' style={{ height: '40px' }} title="Click here to export" type="button" id="expensesButton" onClick={() => this.exportLogDetails()}>
                <FontAwesomeIcon size='sm' style={{ color: '#0465AC' }} icon={["fa", "file-export"]} />
              </span>
              <span className='actionBox' style={{ height: '40px' }}>
                <ReactToPrint
                  trigger={() => {
                    return <span title='Click to print' ><FontAwesomeIcon color='#0465AC' icon={['fas', 'print']} size={'md'} /></span>
                  }}
                  content={() => this.printReference}
                />
              </span>
              <button type="button" onClick={() => this.addlogsModal()} style={{ fontSize: '10px !important', padding: '5px 10px !important' }} className="btn btn-primary br-5">
                <FontAwesomeIcon size='sm' icon={["fa", "plus"]} /> &nbsp;
                <span className='fs-13'>Add/Import logs</span>
              </button>
            </div>
          </div>
          <div className='col-md-12 pl-0 pt-3' >
            <div className="table-responsive" style={{ maxHeight: '65vh', overflowY: 'auto' }} id='tableResponsive'>
              <div ref={el => this.printReference = el}>
                <div className="college-info" style={{ textAlign: 'center' }}>
                  <img src={config.instructorInfo.InstituteLogo} style={{ marginBottom: 10, width: 70, height: 70 }} />
                  <h4 style={{ marginBottom: 10 }}>{ReactHtmlParser(config.instructorInfo.InstituteName)}</h4>
                </div>
                <table className="table table-bordered  vm_libraryReport_table" id="studentWiseLibraryReport">
                  <thead style={{ backgroundColor: "rgb(242 242 242)", position: 'sticky', top: '-1%' }}>
                    <tr>
                      {
                        !this.state.exportDetails &&
                        <th className="printHide" style={{ paddingTop: '0.5rem', paddingBottom: '0.5rem' }}>
                          <input
                            type="checkbox"                            
                            checked={Object.keys(this.state.periodicalAllData).length > 0 && (Object.keys(this.state.periodicalAllData).length == this.state.selectedPeriodicalIds.length)}
                            onChange={(e) => this.selectAllPeriodicals(e)}
                            style={{ marginRight: 5 }}
                          />
                        </th>
                      }
                      <th scope="col">Title</th>
                      <th scope="col">Institute</th>
                      {dateArray.map(date => (
                        <th key={date.toDateString()}>
                          <p className='fs-11'>{`${date.getDate().toString().padStart(2, '0')} ${date.toLocaleDateString('en-US', { month: 'short' })}`}</p>
                          <p className='fs-11'>{`${date.getFullYear()}`}</p>
                          <p className='fs-10'>({`${date.toLocaleDateString('en-US', { weekday: 'short' })}`})</p>
                        </th>
                      ))}
                    </tr>
                    {
                      this.state.selectedPeriodicalIds.length > 0 &&
                      <tr style={{ backgroundColor: "#ffff" }}>
                        <th colSpan={dateArray.length + 2} style={{ padding: '10px' }}>
                          <div className="">
                            <span id="actionOnLogs" title="Click to update daily logs" onClick={() => this.updatelogsModal('update')}>
                              Update Daily Logs
                            </span>
                            <span id="actionOnLogs" title="Click to delete daily logs" onClick={() => this.updatelogsModal('delete')}>
                              Delete Daily Logs
                            </span>
                          </div>
                        </th>
                      </tr>
                    }
                  </thead>
                  <tbody>
                    {
                      this.state.periodicalListLoading ?
                        <tr>
                          <Spinner />
                        </tr>
                        :
                        this.state.sortedIdArray.length > 0 ?
                          this.state.sortedIdArray.map((periodicalId, index) => {
                            let periodical = this.state.periodicalAllData[periodicalId];
                            return (
                              <tr>
                                {
                                  !this.state.exportDetails &&
                                  <th className="printHide" style={{ paddingBottom: '4px' }}>
                                    <input
                                      type="checkbox"
                                      checked={this.state.selectedPeriodicalIds.includes(periodicalId.toString())}
                                      onChange={() => this.selectSinglePeriodical(periodicalId.toString())}
                                      style={{ marginRight: 5 }}
                                    />
                                  </th>
                                }
                                <th scope="row" className='wrap-tableTitle'>{periodical.title}</th>
                                <th scope="row" className='wrap-tableTitle'>{periodical.periodical_InstituteName}</th>
                                {dateArray.map((date, index) => {
                                  let formattedDate = moment(date, 'ddd MMM DD YYYY').format('YYYY-MM-DD');
                                  // Find the log entry for the formatted date
                                  let logEntry;
                                  if (Array.isArray(periodical.logs)) {
                                    logEntry = periodical.logs.find(log => log.receivedDate === formattedDate);
                                  } else if (typeof periodical.logs === 'object') {
                                    logEntry = periodical.logs[formattedDate];
                                  }

                                  let pricePerCopy = this.state.exportDetails ? logEntry ? '₹ ' + logEntry.pricePerCopy : '' : logEntry ? '₹ ' + logEntry.pricePerCopy : '';
                                  let issues = logEntry ? 'Issue ' + logEntry.issueNo : '';
                                  let noOfCopies = logEntry ? 'Copies ' + logEntry.noOfCopies : '';


                                  // Define styles based on whether logEntry exists
                                  let tdStyle = {
                                    backgroundColor: logEntry ? '#D2EEE7' : 'transparent',
                                    padding: '10px', // Example padding
                                  };

                                  // Define box-shadow for border effect
                                  if (logEntry) {
                                    tdStyle.boxShadow = `
                                    inset 0 1px 0 0 #52C3A8,
                                    inset 1px 0 0 0 #52C3A8
                                  `;
                                  }

                                  return (
                                    <td key={formattedDate} style={tdStyle}>
                                      <p style={{ color: '#178E63', fontSize: '11px', fontWeight: '500' }}>{pricePerCopy}</p>
                                      <p style={{ color: '#178E63', fontSize: '11px', fontWeight: '500' }}>{issues}</p>
                                      <p style={{ color: '#178E63', fontSize: '11px', fontWeight: '500' }}>{noOfCopies}</p>
                                    </td>
                                  )
                                })}
                              </tr>
                            )
                          })
                          :
                          <tr><td colSpan={dateArray.length + 2}>No periodicals added.</td></tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>

          </div>
        </div>
        {
          this.returnAddLogs()
        }
        {
          this.returnUpdateLogs()
        }
      </>
    )
  }
}

const mapStateToProps = store => {
  return {
    // VARIABLES TO GET AGENCY DETAILS
    accessibleOperations: store.RouteMenuReducer.accessibleOperations,
    isAdmin: store.RouteMenuReducer.isLibraryAdmin,
    iidArray: { ...store.RouteMenuReducer.iidArray },
    multipleInstituteDetails: { ...store.RouteMenuReducer.multipleInstituteDetails }
  };
};

export default connect(mapStateToProps)(DailyLogs);